// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("C:\\jarrive\\app\\(tabs)\\_layout.tsx"); } },
  "./(tabs)/explore.tsx": { enumerable: true, get() { return require("C:\\jarrive\\app\\(tabs)\\explore.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("C:\\jarrive\\app\\(tabs)\\index.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("C:\\jarrive\\app\\_layout.tsx"); } },
  "./join/[code].tsx": { enumerable: true, get() { return require("C:\\jarrive\\app\\join\\[code].tsx"); } },
  "./join/index.tsx": { enumerable: true, get() { return require("C:\\jarrive\\app\\join\\index.tsx"); } },
  "./modal.tsx": { enumerable: true, get() { return require("C:\\jarrive\\app\\modal.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;